<section [class.expanded]="expanded" fxLayout="column">
  <header fxLayout="row" fxLayoutAlign="space-between center">
    <h2>{{ wasteProfiles?.length }} {{ columnTitle }}</h2>
    <button
      mat-button
      color="accent"
      *ngIf="expandable"
      (click)="onExpand()"
      fxHide.lt-lg="true"
    >
      <mat-icon [svgIcon]="expanded ? 'compress' : 'expand'"></mat-icon>
      {{ expanded ? 'Compress' : 'All' }}
    </button>
  </header>
  <main>
    <cdk-virtual-scroll-viewport
      *ngIf="wasteProfiles?.length !== 0 || loading"
      appendOnly
      [itemSize]="expanded ? 45 : 140"
    >
      <div
        *cdkVirtualFor="let wasteProfile of wasteProfiles"
        class="waste-profile-card"
      >
        <ng-container [ngSwitch]="mode">
          <digital-platform-waste-profile-card
            *ngSwitchCase="'CUSTOMER'"
            [user]="user"
            [wasteProfile]="wasteProfile"
            (delete)="onDelete($event)"
          ></digital-platform-waste-profile-card>

          <digital-platform-waste-profile-admin-card
            *ngSwitchCase="'ADMIN'"
            [user]="user"
            [wasteProfile]="wasteProfile"
          ></digital-platform-waste-profile-admin-card>
          <some-element *ngSwitchDefault>...</some-element>
          <digital-platform-waste-profile-card
            *ngSwitchDefault
            [user]="user"
            [wasteProfile]="wasteProfile"
            (delete)="onDelete($event)"
          ></digital-platform-waste-profile-card>
        </ng-container>
      </div>
      <digital-platform-waste-profile-card-loader
        *ngIf="loading"
      ></digital-platform-waste-profile-card-loader>
    </cdk-virtual-scroll-viewport>
    <div class="no-results" *ngIf="wasteProfiles?.length === 0 && !loading">
      <ng-container
        [ngTemplateOutlet]="emptyContent?.templateRef"
      ></ng-container>
    </div>
  </main>
</section>
